import React, { useEffect, useRef, useState } from 'react';
import { UnoStoreHooks, defaultLogo } from "@simulanisindia/ui";
import {
    ALL,
    APPLICATION_LIMIT,
    MODULE_LIMIT,
    PLAN_DETAIL_TAB,
    RESOURCE_APPLICATION_TAB, RESOURCE_ENVIRONMENT_TAB,
    RESOURCE_MODULE_TAB, RESOURCE_SKILL_SCHOOL_TAB,
    RESOURCE_SKILL_STREAM_TAB,
    VALIDITY_TAB
} from '../../../Constant/constant';
import { makeFilterParams, toggleArrayByObject } from '../../../Utils/general';
import { UNO_URL, SSO_URL } from '../../../env';
import { getAssignedApplication, getAssignedModuleList } from '../../../Utils/apiCall';
import Section from './Section';
import PlanDetails from '../../../components/Management/PlanDetails';
import ValiditySection from '../../../components/Validity/ValiditySection';


const { useUnoSelector } = UnoStoreHooks;

const SelectResource = ({ activeTab }) => {

    const configData = useUnoSelector((state) => state.config);
    const userData = useUnoSelector((state) => state.user);
    const [showfilter, setShowFilter] = useState(false);
    const [selectCheckBoxAll, setSelectCheckBoxAll] = useState(false);

    const [querySearch, setQuerySearch] = useState({
        [RESOURCE_APPLICATION_TAB]: "",
        [RESOURCE_MODULE_TAB]: "",
        [RESOURCE_ENVIRONMENT_TAB]: "",
        [RESOURCE_SKILL_STREAM_TAB]: "",
        [RESOURCE_SKILL_SCHOOL_TAB]: "",
    });
    const [search, setSearch] = useState({
        [RESOURCE_APPLICATION_TAB]: "",
        [RESOURCE_MODULE_TAB]: "",
        [RESOURCE_ENVIRONMENT_TAB]: "",
        [RESOURCE_SKILL_STREAM_TAB]: "",
        [RESOURCE_SKILL_SCHOOL_TAB]: "",
    });
    const [loading, setLoading] = useState({
        [RESOURCE_APPLICATION_TAB]: true,
        [RESOURCE_MODULE_TAB]: true,
        [RESOURCE_ENVIRONMENT_TAB]: true,
        [RESOURCE_SKILL_STREAM_TAB]: true,
        [RESOURCE_SKILL_SCHOOL_TAB]: true,
    });
    const [checkedFilterItem, setCheckedFilterItem] = useState({
        [RESOURCE_APPLICATION_TAB]: [],
        [RESOURCE_MODULE_TAB]: [],
        [RESOURCE_ENVIRONMENT_TAB]: [],
        [RESOURCE_SKILL_STREAM_TAB]: [],
        [RESOURCE_SKILL_SCHOOL_TAB]: [],
    });
    const [queryCheckedItem, setQueryCheckedItem] = useState({
        [RESOURCE_APPLICATION_TAB]: [],
        [RESOURCE_MODULE_TAB]: [],
        [RESOURCE_ENVIRONMENT_TAB]: [],
        [RESOURCE_SKILL_STREAM_TAB]: [],
        [RESOURCE_SKILL_SCHOOL_TAB]: [],
    });
    const prevQuerySearch = useRef(querySearch);
    const prevQueryCheckedItem = useRef(queryCheckedItem);

    const [applicationList, setApplicationList] = useState({
        hasMore: true,
        page: 1,
        list: [],
    });
    const [moduleList, setModuleList] = useState({
        hasMore: true,
        page: 1,
        list: [],
    });
    const [environmentList, setEnvironmentList] = useState({
        hasMore: true,
        page: 1,
        list: [],
    });
    const [skillStreamList, setSkillStreamList] = useState({
        hasMore: true,
        page: 1,
        list: [],
    });

    const [skillSchoolList, setSkillSchoolList] = useState({
        hasMore: true,
        page: 1,
        list: [],
    });

    const getPaginatedAssignedModules = async (pageNumber, querySearch, selectedItem = [], resourceType) => {
        try {
            let filterParams = {};
            if (selectedItem.length > 0) {
                filterParams = makeFilterParams(selectedItem);
            }
            let page = pageNumber || 1;
            let queryParams = {
                page: page,
                search: querySearch,
                ...filterParams,
            };
            let data = await getAssignedModuleList({ SSO_URL, UUID: userData.user.uuid, queryParams, resourceType });

            let fetchStates = {
                [RESOURCE_MODULE_TAB]: setModuleList,
                [RESOURCE_ENVIRONMENT_TAB]: setEnvironmentList,
                [RESOURCE_SKILL_STREAM_TAB]: setSkillStreamList,
                [RESOURCE_SKILL_SCHOOL_TAB]: setSkillSchoolList,
            };

            fetchStates[resourceType]((pre) => ({
                hasMore: data.length === MODULE_LIMIT,
                page: data.length === MODULE_LIMIT ? page + 1 : page,
                list: page === 1 ? [...data] : [...pre.list, ...data],
            }));
        } catch (error) {
            console.log(error);
        } finally {
            setLoading((pre) => ({
                ...pre,
                [resourceType]: false,
            }));
        }
    };

    const getPaginatedApplications = async (pageNumber, querySearch, selectedItem = []) => {
        try {
            let page = pageNumber || 1;
            let queryParams = {
                page: page,
                search: querySearch,
                tagIds: selectedItem.length > 0 ? selectedItem.map((e) => e.key) : null,
            };
            let data = await getAssignedApplication({ SSO_URL, UUID: userData.user.uuid, queryParams });

            setApplicationList((pre) => ({
                hasMore: data.length === APPLICATION_LIMIT,
                page: data.length === APPLICATION_LIMIT ? page + 1 : page,
                list: page === 1 ? [...data] : [...pre.list, ...data],
            }));
        } catch (error) {
            console.log(error);
        } finally {
            setLoading((pre) => ({
                ...pre,
                [RESOURCE_APPLICATION_TAB]: false,
            }));
        }
    };

    useEffect(() => {
        Object.keys(querySearch).forEach((tab) => {
            if (
                prevQuerySearch.current[tab] !== querySearch[tab] ||
                prevQueryCheckedItem.current[tab] !== queryCheckedItem[tab]
            ) {

                let tabsType = {
                    [RESOURCE_APPLICATION_TAB]: RESOURCE_APPLICATION_TAB,
                    [RESOURCE_MODULE_TAB]: RESOURCE_MODULE_TAB,
                    [RESOURCE_ENVIRONMENT_TAB]: RESOURCE_ENVIRONMENT_TAB,
                    [RESOURCE_SKILL_STREAM_TAB]: RESOURCE_SKILL_STREAM_TAB,
                    [RESOURCE_SKILL_SCHOOL_TAB]: RESOURCE_SKILL_SCHOOL_TAB,
                };

                if (tab === RESOURCE_APPLICATION_TAB) {
                    getPaginatedApplications(1, querySearch[tab], queryCheckedItem[tab]);
                } else {
                    getPaginatedAssignedModules(1, querySearch[tab], queryCheckedItem[tab], tabsType[tab]);
                }
            }
        });
        prevQuerySearch.current = querySearch;
        prevQueryCheckedItem.current = queryCheckedItem;
    }, [querySearch, queryCheckedItem]);

    useEffect(() => {
        const timer = setTimeout(() => {
            setQuerySearch(search);
            setQueryCheckedItem(checkedFilterItem);
        }, 500);
        return () => clearTimeout(timer);
    }, [search, checkedFilterItem]);

    // const openFilter = (e) => {
    //     setShowFilter((pre) => !pre);
    // };

    const loadMoreData = () => {

        const mapping = {
            [RESOURCE_APPLICATION_TAB]: {
                storedValue: applicationList,
                callerFunction: getPaginatedApplications,
            },
            [RESOURCE_MODULE_TAB]: {
                storedValue: moduleList,
                callerFunction: getPaginatedAssignedModules,
            },
            [RESOURCE_ENVIRONMENT_TAB]: {
                storedValue: environmentList,
                callerFunction: getPaginatedAssignedModules,
            },
            [RESOURCE_SKILL_STREAM_TAB]: {
                storedValue: skillStreamList,
                callerFunction: getPaginatedAssignedModules,
            },
            [RESOURCE_SKILL_SCHOOL_TAB]: {
                storedValue: skillSchoolList,
                callerFunction: getPaginatedAssignedModules,
            },
        };
        mapping[activeTab].callerFunction(
            mapping[activeTab].storedValue.page,
            search[activeTab],
            queryCheckedItem[activeTab],
            activeTab
        );
    };

    const fetchInitialAppData = () => {
        setLoading({
            [RESOURCE_APPLICATION_TAB]: true,
            [RESOURCE_MODULE_TAB]: true,
            [RESOURCE_ENVIRONMENT_TAB]: true,
            [RESOURCE_SKILL_STREAM_TAB]: true,
            [RESOURCE_SKILL_SCHOOL_TAB]: true,
        });
        getPaginatedApplications(1, null, []);
        getPaginatedAssignedModules(1, null, [], RESOURCE_MODULE_TAB);
        getPaginatedAssignedModules(1, null, [], RESOURCE_ENVIRONMENT_TAB);
        getPaginatedAssignedModules(1, null, [], RESOURCE_SKILL_STREAM_TAB);
        getPaginatedAssignedModules(1, null, [], RESOURCE_SKILL_SCHOOL_TAB);
    };

    useEffect(() => {
        fetchInitialAppData();
    }, []);

    const handleSetSearch = (e) => {
        setSearch((pre) => ({ ...pre, [activeTab]: e.target.value }));
    };

    let renderList = {
        [RESOURCE_APPLICATION_TAB]:
            applicationList.list
                .filter((e) => e.uuid !== configData.config.applicationId)
                .map((item) => ({ title: item.name, id: item.uuid, icon: item.icon, description: item.description, banner: item.banner })) || [],
        [RESOURCE_MODULE_TAB]:
            moduleList.list.map((item) => ({
                title: item.name,
                id: item.uuid,
                description: item?.versions[0]?.data?.short || null,
                icon: item?.versions[0]?.data?.thumbnail || defaultLogo,
            })) || [],
        [RESOURCE_ENVIRONMENT_TAB]:
            environmentList.list.map((item) => ({
                title: item.name,
                id: item.uuid,
                description: item?.versions[0]?.data?.description || null,
                icon: item?.versions[0]?.data?.thumbnail || defaultLogo,
            })) || [],
        [RESOURCE_SKILL_STREAM_TAB]:
            skillStreamList.list.map((item) => ({
                title: item.name,
                id: item.uuid,
                description: item.description,
                icon: item?.versions[0]?.data?.thumbnail || defaultLogo,
            })) || [],
        [RESOURCE_SKILL_SCHOOL_TAB]:
            skillSchoolList.list.map((item) => ({
                title: item.name,
                id: item.uuid,
                description: item.description,
                icon: item?.versions[0]?.data?.thumbnail || defaultLogo,
            })) || [],
    };

    let haveSomeMoreData = {
        [RESOURCE_APPLICATION_TAB]: applicationList.hasMore,
        [RESOURCE_MODULE_TAB]: moduleList.hasMore,
        [RESOURCE_ENVIRONMENT_TAB]: environmentList.hasMore,
        [RESOURCE_SKILL_STREAM_TAB]: skillStreamList.hasMore,
        [RESOURCE_SKILL_SCHOOL_TAB]: skillSchoolList.hasMore,
    };

    const [selectedResource, setSelectedResource] = useState({
        application: [],
        module: [],
    });

    const openFilter = (e) => {
        setShowFilter((pre) => !pre);
    };

    const [checkBoxAll, setCheckBoxAll] = useState({
        [ALL]: false,
        [RESOURCE_APPLICATION_TAB]: false,
        [RESOURCE_MODULE_TAB]: false,
        [RESOURCE_ENVIRONMENT_TAB]: false,
        [RESOURCE_SKILL_STREAM_TAB]: false,
        [RESOURCE_SKILL_SCHOOL_TAB]: false,
    });


    const handleSelectAllTrigger = (status) => {
        setSelectCheckBoxAll(status);
    };

    const handleClickSelectCheckbox = (item) => {
        setCheckedFilterItem((pre) => ({
            ...pre,
            [activeTab]: toggleArrayByObject(pre[activeTab], item)
        }))
    }

    const handleResetCheckBox = () => {
        setCheckedFilterItem((pre) => ({
            ...pre,
            [activeTab]: []
        }))
    }

    return (
        <>
            <Section
                renderList={renderList[activeTab]}
                allTabResources={renderList}
                hasMore={haveSomeMoreData[activeTab]}
                loading={loading[activeTab]}
                search={search[activeTab]}
                setSearch={handleSetSearch}
                selectedResource={selectedResource}
                setSelectedResource={setSelectedResource}
                openFilter={openFilter}
                activeTab={activeTab}
                loadMoreData={loadMoreData}
                checkBoxAll={checkBoxAll}
                setCheckBoxAll={setCheckBoxAll}
                selectCheckBoxAllClicked={handleSelectAllTrigger}
                checkedFilterItem={checkedFilterItem}
                setCheckedFilterItem={setCheckedFilterItem}
            />
        </>
    )

}

export default SelectResource;